import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject,ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { HomepageService } from '../../../services/homepage.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  private readonly notifier: NotifierService;
	constructor(@Inject(DOCUMENT) private document: Document, private authService : AuthService, private activatedRoute : ActivatedRoute, private router : Router, private homepageService :HomepageService, notifierService: NotifierService) {
    this.notifier = notifierService;
  }
  canLogin = false;
	reseting: boolean = false;
	code: any = '';
	userId: number;
  loading:boolean = false;
  passwordRequirement:any;
  globalSetting:any;
  ngOnInit() {
  	this.document.body.classList.add('inner-page');
  	this.activatedRoute.queryParams.subscribe(params => {
        this.code = params['code'];
        this.userId = params['userid'];
    });
    this.authService.getPasswordRequirement(0).subscribe(passwordReq => {
      this.passwordRequirement = passwordReq;
    },(passwordErr) =>{
      //Will update soon.
    });
    this.globalSetting = this.homepageService.getUpdatedConfig();
  }

  ngAfterViewInit() {
    $('#login-modal').removeClass('show').addClass('hide');
    $('#login-modal').removeClass('background-disable');

  }

  //This component to handle BE request to reset password.
  //checking if pasword following requirements.
  changeSubmit(event){
    $('#loginErrorPass').html('');
    var error = false;
    var password = $("#newpassword").val().toString();
    var passwordC = $("#new-comformpassword").val().toString();
    if(this.passwordRequirement.data.minimumLength){
      if($.trim(password).length < this.passwordRequirement.data.minimumLength ){
        error=true;
        $('#loginErrorPass').append("<li class='text-danger'>Password length atleast "+this.passwordRequirement.data.minimumLength+" characters</li>");
        return false;
      }
    }
    if(this.passwordRequirement.data.mixedCase){
      if( !$.trim(password).match(/[A-Z]/) || !$.trim(password).match(/[a-z]/)){
        error=true;
        $('#loginErrorPass').append("<li class='text-danger'>Password must contains one uppercase and one lowercase characters</li>");
        return false;
      }
    }
    if(this.passwordRequirement.data.digitsLetterCombination){
      if( !$.trim(password).match(/[A-Za-z]/) || !$.trim(password).match(/[0-9]/)) {
        error=true;
        $('#loginErrorPass').append("<li class='text-danger'>Password must contain atleast one digit and one character</li>");
        return false;
      }
    }
    if(this.passwordRequirement.data.nonAlphanumeric){
      var format = /[ `!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?~]/;
      if(!format.test($.trim(password))){
        error=true;
        $('#loginErrorPass').append("<li class='text-danger'>Password must contain atleast one special character</li>");
        return false;
      }
    }
    if(passwordC != ''){
      if(password != passwordC){
        error=true;
        $('#loginErrorPass').append("<li class='text-danger'>Confirm Password didn't match</li>");
        return false;
      }
    }
    if(error == false){
      $('.submit-btn').removeAttr('disabled');
    }else{
      $('.submit-btn').attr('disabled', 'disabled');
      return false;
    }
    //small latters
    if(event.key == 'Enter' && event.keyCode ==13 ){
       this.resetPassword();
    }
  }

  //Reset password API manually...
  resetPassword(){
    this.loading = true;
    var newPassword 	= $.trim($('#newpassword').val().toString());
  	this.reseting = true;
    var locationId = this.homepageService.getLocationId(); 
  	return this.authService.resetPassword(newPassword, this.code, this.userId, locationId).subscribe((response) => {
  		this.reseting = false;
      if(response.status){
        if(this.globalSetting.data.settings.patron.login.required){
          $('#login-modal').addClass('background-disable');
          $('#login-modal').attr('data-backdrop','static');
        }
        this.notifier.notify('success', response.message );
        $('#loginLi').click();
        var router = this.router;
        var loginBtnTemp = $('body').find('#loginLia:first')[0];
        loginBtnTemp.click();
        setTimeout(function(){
          //router.navigate(['/']);                  
        }, 5000);
      }else{
        this.notifier.notify('error', response.message );
      }
      this.loading = false;
  	},(err) => {
      this.loading = false;
  		this.reseting = false;
  		if(err.error.status != 200){
      	var errorHtml = '';
  			if(err.error.status == 400 && err.error.errors){
          this.notifier.notify('error', err.error.title );
  				$.each(err.error.errors, function(key,val){
            this.notifier.notify('error', val );
				});
  			} else {
          this.notifier.notify('error', err.error.message );
  			}
  		}
    });
  }  	
}
